import {
  Alert,
  Box,
  Collapse,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { ExpandLess, ExpandMore, Remove } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CollapseRadioButtonsList = (props) => {
  const { items, value, onChange, name, id } = props || {};
  const [openCategories, setOpenCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    if (value != 0) {
      setSelectedCategory(value); // Postavljamo inicijalno selektovan ID
      const parentsToOpen = findParents(items, value); // Pronađi sve roditelje
      if (parentsToOpen) setOpenCategories(parentsToOpen);
    }
  }, [id, items, value]);

  const handleToggleCategory = (id) => {
    setOpenCategories((prevState) =>
      prevState.includes(id)
        ? prevState.filter((categoryId) => categoryId !== id)
        : [...prevState, id]
    );
  };

  const handleSelectCategory = (event) => {
    const value = event.target.value;
    setSelectedCategory(value); // Ažuriranje lokalnog stanja
    if (onChange) {
      onChange({ target: { name, value } }); // Prosleđivanje vrednosti roditelju
    }
  };

  const findParents = (categories, childId, parents = []) => {
    for (const category of categories) {
      if (category.id === childId) {
        return parents; // Vraćamo sve roditelje ako nađemo dete
      }
      if (category.children) {
        const result = findParents(category.children, childId, [
          ...parents,
          category.id,
        ]);
        if (result) {
          return result;
        }
      }
    }
    return null;
  };

  const renderCategories = (categories, depth = 0) => {
    return categories.map((category) => {
      const isCategoryOpen = openCategories.includes(category.id);
      const marginLeft = depth * 20; // Tačno uvlačenje za svaku dubinu (10px po dubini)
      return (
        <Box key={category.id} sx={{ marginLeft: `${marginLeft}px` }}>
          <FormControl component="fieldset">
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {/* Ikona za expand/collapse ili neutralna ikonica */}
              <Box
                sx={{
                  cursor: category.children?.length > 0 ? "pointer" : "default",
                  marginRight: 1,
                }}
                onClick={
                  category.children?.length > 0
                    ? () => handleToggleCategory(category.id)
                    : undefined
                }
              >
                {category.children?.length > 0 ? (
                  isCategoryOpen ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : (
                  <Remove sx={{ color: "transparent" }} /> // Neutralna ikonica
                )}
              </Box>

              {/* Radio dugme i tekst */}
              <FormControlLabel
                control={<Radio />}
                label={category.name}
                value={category.id}
                checked={selectedCategory === category.id}
                onChange={handleSelectCategory}
              />
            </Box>
            {/* Ako postoji children, renderujemo ih u Collapse komponenti */}
            <Collapse in={isCategoryOpen} timeout="auto" unmountOnExit>
              {category.children &&
                renderCategories(category.children, depth + 1)}
            </Collapse>
          </FormControl>
        </Box>
      );
    });
  };

  return (
    <Box>
      {items?.length > 0 ? (
        <RadioGroup value={selectedCategory} onChange={handleSelectCategory}>
          {renderCategories(items)}
        </RadioGroup>
      ) : (
        <Alert severity="info">{t("productsForm.message1")}</Alert>
      )}
    </Box>
  );
};

export default CollapseRadioButtonsList;
